import type { FaireThemeEntity } from "../../entity_types/theme";

export const versatile_pop_up_layers: FaireThemeEntity = {
  token: "versatile-pop-up-layers",
  type: "theme",
  name: "Versatile Pop-Up Layers",
  description: "Easy-to-style cardigans and accessories for leisure fashion -- high-impact items easy to display.",
  teaser: "High-impact layers that are easy to rack and sell at pop-ups.",
  detail: "Your strong history of knit sweaters, cardigans, and sweatshirts makes these a natural fit. Based on your recent dwell time on the kycozy Fashion Contrast Print Cardigan and similar casual-fashion pieces.",
  bgColor: "#F5D6D6",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_c4z26gu3ds",
    "p_kdspx6vu84",
    "p_e8b6rxq4x3",
    "p_4w7a6pw4dz",
    "p_42n546c9et",
    "p_mdzwes5fgm",
    "p_h7chgnadmg",
    "p_ar6v7butev",
    "p_x35tyb7gp9",
    "p_cpa46rtxys",
    "p_nb2s54h26m",
    "p_3dbzjmnsy9",
    "p_6zvcyk4d36",
    "p_df4zvmzr7p",
    "p_ghsxdz7myv",
    "p_e5tq8j5b34",
    "p_x48c83x7w8",
    "p_mgzz9ym525",
    "p_f7nm9hs8f4",
    "p_trpp5ad4tc",
    "p_r4qt2uprvh",
    "p_eryphrnxqg",
    "p_3dze777h6z",
    "p_ykr53mdpug",
    "p_dv4jtvctj9",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
